import axios from '../utils/axios';

export default function addClient(adminId,data) {
    return (
        axios.post('/admin/' + adminId +'/add-client',  data )
    )
}